// extracted by mini-css-extract-plugin
export default {"section":"Layout_section__XrEeI","main":"Layout_main__FV28D","aside":"Layout_aside__RmJ78"};